export const GET_NEWSLETTER_LIST = "GET_NEWSLETTER_LIST"
export const GET_NEWSLETTER_LIST_SUCCESS = "GET_NEWSLETTER_LIST_SUCCESS"
export const GET_NEWSLETTER_LIST_FAIL = "GET_NEWSLETTER_LIST_FAIL"

